<script setup lang="ts">
import {useCache} from "~/common/useCache";

const { gtag } = useGtag()
const app = useAppStore()
const moveToMain = () => {
  useRouter().replace('/')
}
onMounted(() => {
  gtag('event', 'open_error_page', {
    um_idx: app.user ? app.user.UM_IDX : '',
    date: new Date().toISOString(),
  })
})
</script>

<template>
  <!-- #loginWrap -->
  <div id="signupWrap">
    <div id="signupContainer">
      <div class="error-page">
        <h1>해당 페이지를 <br />찾을 수 없습니다.</h1>
        <p>아래의 버튼을 눌러 이동해 주세요</p>

        <section class="btnWrap mt02 center">
          <a class="btnStyle" @click="moveToMain">홈으로</a>
        </section>
      </div>
    </div>
  </div>
  <!-- /#loginWrap -->
</template>

<style scoped>
/* Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  color: #222;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  letter-spacing: -0.3px;
  word-break: keep-all;
  -webkit-text-size-adjust: none;
}

/* Layout */
#__nuxt {
  width: 100%;
  min-height: 100vh;
}
:has(#signupWrap) {
  html,
  body,
  #signupWrap {
    background: #f6f7fb;
  }
}
#signupWrap {
  display: flex;
  flex-direction: column;
}
#signupContainer {
  padding: 96px;
  width: 768px;
  margin: 0 auto;
}
#signupWrap {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff;
}

/* Error Page */
.error-page {
  text-align: center;
}

/* Button Area */
.btnWrap {
  display: flex;
  gap: 8px;
}
.btnWrap.mt02 {
  margin-top: 32px;
}

.btnWrap.center {
  justify-content: center;
}
.btnWrap a {
  min-width: 200px;
}
.btnWrap a.wide {
  flex: 1;
}
.btnStyle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #6b40e6;
  border: 1px solid #6b40e6;
  border-radius: 8px;
  height: 64px;
  padding: 0 20px;
  color: #fff;
  font-weight: 700;
  box-sizing: border-box;
  transition: all 0.15s linear;
  font-size: 18px;
}

.btnStyle:hover {
  color: #512eab;
  border-color: #512eab;
}

#signupContainer:has(.error-page) {
  margin: auto;
}
.error-page {
  text-align: center;
}
.error-page h1 {
  padding-top: 264px;
  font-size: 36px;
  font-weight: 700;
  background: url('~/assets/images/board/img_404.svg') center 0 no-repeat;
}
.error-page p {
  margin-top: 12px;
  color: #5b5e61;
}
</style>
